import { localize } from '../i18n';
import React from 'react';
import { Box, CircularProgress } from '@mui/material';

export default function LoadingLabel({ children = localize('처리 중...') }) {
    return <Box component="span" role="status" sx={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 0.8 }}>
        <CircularProgress size={16} color="inherit" aria-label={localize("처리 중")} />
        {children}
    </Box>;
}
